/* Small floated images.

Authors mark an image by dropping an HTML card holding
<span class="next-image-small-left"></span> (or -right) next to a
figure.kg-image-card. The image is shrunk to a fraction of the column and, when
body copy follows it, the image and that copy are moved into a wrapper div so
the text can wrap around the float.

The wrapper is what makes the float work at all: .gh-content is a grid, and a
grid only lays out its direct children, so a float sitting directly on the grid
has nothing to wrap. Moving the image and its text into a single grid item
gives the float an ordinary block context to live in.

Ghost cards are never moved - the run stops at the first sibling that isn't a
paragraph or list.

There is a second authoring route for the same layout: a set of HTML cards that
build a .tn-side-left / .tn-side-right div around the image and its text (see
docs/side-image-snippets.md). That markup is shaped for email, where there is no
JavaScript and Gmail strips any stylesheet an HTML card provides: the image and
text sit in two inline-block columns carrying inline styles, which sit side by
side when they fit and stack when they don't. Here on the web we'd rather have a
real float, so we unpick those columns and hand the wrapper to the same rules
the marker spans use. */

function floatImages() {
    var MARKER = '.next-image-small-left, .next-image-small-right';
    var WRAPPABLE = {P: true, UL: true};

    function isMarker(el) {
        return !!el && el.nodeType === 1 && el.matches(MARKER);
    }

    /* Markers and images sit side by side on the grid, so step over any other
    marker that happens to fall between them. */
    function sibling(el, direction) {
        var node = el[direction];
        while (isMarker(node)) {
            node = node[direction];
        }
        return node;
    }

    function isImageCard(el) {
        return !!el && el.nodeType === 1 && el.matches('figure.kg-image-card');
    }

    function isWrappable(el) {
        return !!el && el.nodeType === 1 && WRAPPABLE[el.tagName] === true &&
            !el.classList.contains('kg-card');
    }

    function applyMarkers(content) {
        content.querySelectorAll(MARKER).forEach(function (marker) {
            /* The marker can be nested inside the HTML card's own markup, so
            work from whichever ancestor actually sits on the grid. */
            var anchor = marker;
            while (anchor.parentElement && anchor.parentElement !== content) {
                anchor = anchor.parentElement;
            }
            if (anchor.parentElement !== content) return;

            var figure = sibling(anchor, 'nextElementSibling');
            if (!isImageCard(figure)) {
                figure = sibling(anchor, 'previousElementSibling');
            }
            /* smaller-image doubles as the "already handled" flag, so calling
            this twice is harmless. */
            if (!isImageCard(figure) || figure.classList.contains('smaller-image')) return;

            figure.classList.add('smaller-image');

            /* No body copy to wrap around it, so leave it on the grid - the
            stylesheet keeps it small and centres it. */
            if (!isWrappable(sibling(figure, 'nextElementSibling'))) return;

            var side = marker.classList.contains('next-image-small-right') ? 'right' : 'left';
            var wrapper = document.createElement('div');
            wrapper.className = 'gh-float-wrap gh-float-' + side;
            content.insertBefore(wrapper, figure);
            wrapper.appendChild(figure);

            var node = sibling(wrapper, 'nextElementSibling');
            while (isWrappable(node)) {
                var following = sibling(node, 'nextElementSibling');
                wrapper.appendChild(node);
                node = following;
            }
        });
    }

    function applyInserts(content) {
        content.querySelectorAll('.tn-side-left, .tn-side-right').forEach(function (wrapper) {
            /* gh-float-wrap doubles as the "already handled" flag. */
            if (wrapper.classList.contains('gh-float-wrap')) return;

            /* Lift the image and the text out of the two email columns so they
            become ordinary siblings the float can work on. */
            wrapper.querySelectorAll('.tn-side-media, .tn-side-body').forEach(function (column) {
                while (column.firstChild) {
                    wrapper.insertBefore(column.firstChild, column);
                }
                column.remove();
            });

            /* The wrapper's inline styles are the email layout - font-size:0 and
            the rtl flip among them. Both would wreck the page, and neither is
            wanted once the columns are gone. */
            wrapper.removeAttribute('style');

            var figure = wrapper.querySelector('figure.kg-image-card');
            if (!figure) return;

            figure.classList.add('smaller-image');
            wrapper.classList.add('gh-float-wrap');
            wrapper.classList.add(
                wrapper.classList.contains('tn-side-right') ? 'gh-float-right' : 'gh-float-left'
            );
        });
    }

    document.querySelectorAll('.gh-content').forEach(function (content) {
        applyMarkers(content);
        applyInserts(content);
    });
}
